import React from 'react'

// Styles
import { StyledPill } from './DiscoverNewContentPill.styles'

const DiscoverNewContentPill: React.FC = () => {
  return <StyledPill variant="secondary">New</StyledPill>
}

export default DiscoverNewContentPill
